import React, { useCallback, useEffect, useMemo, useState } from 'react'
import BannerSlide, { BANNER_GROUP } from '../../../components/banner-slide/BannerSlide'
import { bannerSlideType, FrontApi, newsType } from '../../../api/front-api/front.api'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { Box, Divider, Typography } from '@mui/material'
import StateComponents from '../../../components/state-component/StateComponents'
import { icons } from '../../../assets/icons/icons'
import { PollVoteCard } from '../poll-vote/element/element'
import PaginationCustom from '../../../components/pagination/PaginationCustomTwo'
import { RootState } from '../../../store/store'
import clsx from 'clsx'
import { ContentCard, PopularBox } from './element/element'
import Hashids from 'hashids'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../routes/routeName'
import { debouncedApiCall, shareToFacebook, shareToLine, shareToX } from '../../../utils/app.utils'
import { BANNER_TYPE } from '../../cms-website/website-structure/content/enum/content.enum'
import { useTranslation } from 'react-i18next'
import { likeContent, SOCIAL_MEDIA_TYPE } from '../../../utils/global.func'

type Props = {}

const PressRelease: React.FC<Props> = ({ }: Props) => {
    const { t, i18n } = useTranslation();
    const language = i18n.language
    const dispatch = useDispatch();
    const img_url = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate();
    const content_url = useSelector((state: RootState) => state.api.public_content_api);


    const content_status: { label: string, value: string }[] = useMemo(() => {
        return [
            {
                label: t("HOME_PAGE_NEW_ARRIVAL"),
                value: "new"
            },
            {
                label: t("HOME_PAGE_TRENDING"),
                value: "hot"
            },
            {
                label: t("HOME_PAGE_ALL"),
                value: "all"
            },
        ]
    }, [language])
    const [search, setSearch] = useState<string>("");
    const [category, set_category] = useState<any[]>([]);
    const [id_category, set_id_category] = useState<any>(null);
    const [banner_slide_data, set_banner_slide_data] = useState<any[]>([]);
    const [top_five_news, set_top_five_news] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, _setPageLimit] = useState<number>(6);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [content_status_name, set_content_status_name] = useState<string>("all");

    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const encodeId = (id_content: number) => {
        const id = hash_ids.encode(id_content);
        navigate(routeName.main.pressReleaseDetail.replace(":id_content", id))
    }

    const handleGetCategory = async () => {
        await FrontApi.category({ limit: 100, page: 1 }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.data?.items;
                set_category(response)
            }
        }).catch((err) => console.log(err))
    }


    const handleGetTopFiveNews = async () => {
        let query: newsType = {
            page: 1,
            limit: 5,
            sortBy: "view_total"
        }
        await FrontApi.news(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_top_five_news(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetBannerSlideData = async () => {
        let query: bannerSlideType = {
            page: 1,
            limit: 10,
            banner_group: BANNER_GROUP.NEWS
        }
        dispatch(setLoading());
        await FrontApi.banner(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_banner_slide_data(response);
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const handleGetContents = useCallback(async () => {
        let query: newsType = {
            page: page,
            limit: pageLimit
        }
        if (id_category) query.id_category = id_category;
        if (content_status_name !== 'all') query.content_status_name = content_status_name;
        if (search) query.keyword = search
        dispatch(setLoading());
        await FrontApi.news(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems)
                setData(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_category, content_status_name, search])

    useEffect(() => {
        handleGetCategory();
        handleGetTopFiveNews();
        handleGetBannerSlideData();
    }, [])
    useEffect(() => {
        handleGetContents();
    }, [handleGetContents])
    return (
        // <div>
        // </div>
        <>
            <BannerSlide banner_type={BANNER_TYPE.TYPE_ONE} banner_slide={banner_slide_data} />
            <Box className="w-full px-6 py-10 m-auto sm:max-w-[1440px] md:max-w-[1920px] min-h-screen">
                <Box className="grid grid-cols-12 gap-8">
                    <Box className="flex flex-col gap-4 col-span-12 xl:col-span-5">
                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        startAdornment: <Box px={2}><icons.SearchNormal /></Box>,
                                        placeholder: t('HOME_PAGE_SEARCH'),
                                        onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    }
                                }
                            ]}
                        />
                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                            <Box component={"section"}>
                                <Typography sx={{ color: "#4A4A4A" }} fontWeight={600} fontSize={24}>
                                    {t("HOME_PAGE_NEWS_STATUS")}
                                </Typography>
                                {content_status?.map((list, i) => {
                                    return (
                                        <Box onClick={() => set_content_status_name(list?.value)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                            'text-[#9E640E]': list?.value === content_status_name
                                        })} key={list?.value}>
                                            <Typography variant='h6' className="py-5">
                                                {list?.label || "-"}
                                            </Typography>
                                            {i !== content_status.length - 1 && (
                                                <Divider />
                                            )}
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Box>
                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                            <Box component={"section"}>
                                <Typography sx={{ color: "#4A4A4A" }} fontWeight={600} fontSize={24}>
                                    {t('HOME_PAGE_CATEGORY')}
                                </Typography>
                                <Box onClick={() => set_id_category(null)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                    'text-[#9E640E] !important': null === id_category
                                })} >
                                    <Typography variant='h6' className="py-5">
                                        {t("HOME_PAGE_ALL_CATEGORIES")}
                                    </Typography>
                                    <Divider />
                                </Box>
                                {category?.map((list, i) => {
                                    return (
                                        <Box onClick={() => set_id_category(list?.id_category)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                            'text-[#9E640E]': list?.id_category === id_category
                                        })} key={list?.id_category}>
                                            <Typography variant='h6' className="py-5">
                                                {list?.category_name || "-"}
                                            </Typography>
                                            {i !== category.length - 1 && (
                                                <Divider />
                                            )}
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Box>

                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                            <Typography sx={{ color: "#4A4A4A" }} fontSize={{ xs: "20px", xl: "24px" }} fontWeight={700}>
                                {t("HOME_PAGE_TOP_5_POLLS_WITH_THE_MOST_VOTES")}
                            </Typography>

                            <PopularBox data={top_five_news?.map((list) => {
                                return {
                                    end_date: list?.form_poll_end,
                                    group_name: list?.category_names,
                                    start_date: list?.form_poll_start,
                                    title: list?.content_name || "-",
                                    total_vote: list?.count
                                }
                            })} />
                        </Box>
                    </Box>
                    <Box className="col-span-12 xl:col-span-7">
                        <ContentCard onChange={(id_content) => {
                            encodeId(id_content);

                            // console.log(id_content, 'id_content')
                            // handleSubmitPollVote(id, id_choice)
                            // console.log(id_form_poll_choice, 'id_form_poll_choice')
                        }}
                            data={data?.map((list) => {
                                const url_img = `${img_url}/${list?.media_file_path}/${list?.media_file_name}`;
                                const id = hash_ids.encode(list?.id_content);
                                const content_path_recommend = `${content_url}/${routeName.main.activityDetail.replace(":id", id)}`;
                                return {
                                    id_key: list?.id_content,
                                    content_status_name: list?.content_status_name,
                                    detail: list?.content_desc || "",
                                    group_name: list?.category_names || "-",
                                    img_url: url_img,
                                    title: list?.content_name || "-",
                                    alt: list?.content_name,
                                    date: list?.content_start_date,
                                    like: +list?.total_like || 0,
                                    shared: +list?.total_shared || 0,
                                    view: +list?.view_total || 0,
                                    is_like: !!list?.is_like,
                                    onLikeClick: () => likeContent(list?.id_content, +list?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (st, id) => {
                                        setData((prev) => {
                                            return prev?.map((list) => {
                                                return list?.id_content == id ? {
                                                    ...list,
                                                    is_like: !list?.is_like,
                                                    total_like: !list?.is_like ? +list?.total_like + 1 : +list?.total_like - 1
                                                } : list
                                            })
                                        })
                                    }),
                                    onShared: {
                                        facebookClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                            shareToFacebook(content_path_recommend)
                                        },
                                        lineClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.LINE)
                                            shareToLine(content_path_recommend, list?.content_name);
                                        },
                                        xClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.X)
                                            shareToX(content_path_recommend, list?.content_name)
                                        },
                                    }
                                }
                            })}
                        />

                        {data?.length > 0 ? (
                            <PaginationCustom
                                page={page}
                                pageLimit={pageLimit}
                                setPage={(np) => setPage(np)}
                                totalItems={totalItems}
                            />
                        ) : (
                            <Typography>
                                {t("HOME_PAGE_NO_INFORMATION")}
                            </Typography>
                        )}
                    </Box>
                </Box>

                {/* <SnackBarCustom
                    open={show_snack}
                    text={"โหวตเรียบร้อย"}
                /> */}
            </Box>
        </>
    )
}

export default PressRelease